import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from '@/components/layout/Layout';
import Home from '@/pages/Home';
import Program from '@/pages/Program';
import Evaluation from '@/pages/Evaluation';
import Endorsements from '@/pages/Endorsements';
import Overview from '@/pages/Overview';
import Awards from '@/pages/Awards';
import Bio from '@/pages/Bio';
import Contact from '@/pages/Contact';
import Media from '@/pages/Media';
import SingleHanded from '@/pages/SingleHanded';
import Socials from '@/pages/Socials';
import RecentActivities from '@/pages/RecentActivities';
import Donate from '@/pages/Donate';
import BuyEbook from '@/pages/BuyEbook';
import BuyEbookSuccess from '@/pages/BuyEbookSuccess';
import BuyEbookCancel from '@/pages/BuyEbookCancel';
import Admin from '@/pages/Admin';
import { Toaster } from '@/components/ui/toaster';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/overview" element={<Overview />} />
              <Route path="/program" element={<Program />} />
              <Route path="/evaluation" element={<Evaluation />} />
              <Route path="/endorsements" element={<Endorsements />} />
              <Route path="/awards" element={<Awards />} />
              <Route path="/bio" element={<Bio />} />
              <Route path="/media" element={<Media />} />
              <Route path="/single-handed" element={<SingleHanded />} />
              <Route path="/single-handed/buy" element={<BuyEbook />} />
              <Route path="/single-handed/buy/success" element={<BuyEbookSuccess />} />
              <Route path="/single-handed/buy/cancel" element={<BuyEbookCancel />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/socials" element={<Socials />} />
              <Route path="/recent-activities" element={<RecentActivities />} />
              <Route path="/recent-activities/:id" element={<RecentActivities />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Layout>
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
